import { render } from "./DisableAuthProviderModal.vue?vue&type=template&id=b6e05526"
import script from "./DisableAuthProviderModal.vue?vue&type=script&lang=js"
export * from "./DisableAuthProviderModal.vue?vue&type=script&lang=js"

import "./DisableAuthProviderModal.vue?vue&type=style&index=0&id=b6e05526&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__